import { css, type Theme } from '@emotion/react';

export const container = css`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  height: 100%;
`;

export const cardContainer = (theme: Theme) => css`
  padding: 16px;
  border: 1px solid ${theme.colors.gray[100]};
  background-color: ${theme.colors.gray[0]};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;

  width: 100%;
  max-width: 100%;
  height: 100%;
`;

export const header = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  min-height: 24px;
`;

const TITLE_LINE_COUNT = 2;

export const content = css`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

/** Reserves two lines and crops anything longer with an ellipsis. */
export const title = (theme: Theme) => css`
  min-height: calc(${theme.typography.bodyMediumBold.lineHeight} * ${TITLE_LINE_COUNT});
  max-height: calc(${theme.typography.bodyMediumBold.lineHeight} * ${TITLE_LINE_COUNT});
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${TITLE_LINE_COUNT};
  -webkit-box-orient: vertical;
  overflow-wrap: anywhere;
  min-width: 0;
`;

export const views = css`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const footer = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${theme.colors.gray[100]};
  padding-top: 5px;
`;

export const actions = css`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const stats = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
`;

export const statsGroup = css`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const data = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${theme.colors.gray[500]};
`;

export const reportsButton = css`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;

export const publicationDate = (theme: Theme) => css`
  color: ${theme.colors.gray[500]};
`;

export const learningResourceTag = css`
  position: absolute;
  bottom: 10px;
  right: 10px;
`;

export const replayTag = css`
  position: absolute;
  top: 8px;
  left: 8px;
`;

export const avatar = (theme: Theme) => css`
  display: flex;
  gap: 8px;
  align-items: center;
  min-width: 0;
  color: ${theme.colors.gray[500]};
`;

export const presenterName = css`
  min-width: 0;
  overflow: hidden;

  span {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

/** Always reserves one tag line so cards with and without references stay the same height. */
export const references = css`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  overflow: hidden;
  min-height: 24px;
  max-height: 24px;
`;
